import { useMemo } from 'react';
import { EmailType } from 'broker/components/EmailEditor/store/types';
import useEmailEditorActions from 'broker/components/EmailEditor/store/useEmailEditorActions';
import useEmailEditorState from 'broker/components/EmailEditor/store/useEmailEditorState';
import useGetContacts from 'broker/components/EmailEditor/useGetContacts';
import CreateCustomerContactModal from 'broker/dialogs/CreateCustomerContactModal';

export default function EmailEditorCreateCustomerContactModal() {
  const {
    emailType,
    recipients: { preSelectedRecipientGroups },
    submissionsWorkspace: { submission },
  } = useEmailEditorState();

  const { retailerContacts, insuredContacts, isContactsLoading } = useGetContacts({
    insuredOrganizationId: submission?.insuredOrganizationId,
  });
  const { customerContactCreated } = useEmailEditorActions();

  const modalContacts = useMemo(() => {
    // Currently there are no usages for creating a retailer contact, leaving it for now, in case we want to add support in the future
    if (emailType === EmailType.Retailer) {
      return retailerContacts.filter((contact) =>
        preSelectedRecipientGroups![0].recipients.find((recipient) => recipient.id === contact.id),
      );
    }
    if (emailType === EmailType.Insured) {
      return insuredContacts;
    }
    return [];
  }, [emailType, retailerContacts, insuredContacts, preSelectedRecipientGroups]);

  return emailType === EmailType.Retailer || emailType === EmailType.Insured ? (
    <CreateCustomerContactModal
      // TODO: encapsulate the logic of getting the first recipient group for the retailer
      contacts={modalContacts}
      contactsIsLoading={isContactsLoading}
      onContactCreated={customerContactCreated}
      insuredName={submission?.insuredName}
    />
  ) : null;
}
